import React from 'react';
import UsersTable from '../../components/UsersTable';
import { StudioPage } from '../../components/StudioPage';

/**
 * 用户管理页面容器
 * 修改时间：2026-06-12
 */
const User = () => {
  return (
    <StudioPage className='studio-management-page'>
      <UsersTable />
    </StudioPage>
  );
};

export default User;
